<template>
    <el-table border :header-cell-style="{ background: '#eef1f6', color: '#606266' }" ref="basicTable"
        @selection-change="selectChange" @current-change="currentChange" @select="onTableSelect" :height="TableHeight"
        :data="tableData" :row-key="rowFun" stripe style="width: 100%;">
        <el-table-column :selectable="selectable" :reserve-selection="true" align="center" v-if="isCheckbox"
            type="selection" width="50">
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" v-for="column in tableHeader" :key="column.label"
            :label="column.label" :width="column.width">
            <template slot-scope="scope">
                <div v-if="column.prop == 'beginTime'">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"
                        @change="changeDatePickerBeginTime" size="mini" style="width: 175px;" v-model="scope.row.beginTime"
                        type="datetime" placeholder="开始日期">
                    </el-date-picker>
                </div>
                <div v-else-if="column.prop == 'endTime'">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptionsCopy"
                        @change="changeDatePicker" size="mini" style="width: 175px;" v-model="scope.row.endTime"
                        type="datetime" placeholder="结束日期">
                    </el-date-picker>
                </div>
                <div v-else-if="column.prop == 'websiteApprovalorgInfo'">
                    <el-tooltip class="item" effect="dark" :content="scope.row.websiteApprovalorgInfoTooltip" placement="top">
                        <span>{{ scope.row.websiteApprovalorgInfo }}</span>
                    </el-tooltip>
                </div>

                <div v-else-if="column.prop == 'websiteApprovalTeamInfo'">
                    <el-tooltip class="item" effect="dark" :content="scope.row.websiteApprovalTeamInfoTooltip" placement="top">
                        <span>{{scope.row.websiteApprovalTeamInfo}} </span>
                    </el-tooltip>
                </div>

                <!-- <div v-else-if="column.prop == 'rejectCause'">
                    <el-popover title="详细" trigger="hover" placement="top" width="200">
                        <p>{{ scope.row.rejectCause }}</p>
                        <div slot="reference">
                            <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{ scope.row.rejectCause}}</p>
                        </div>
                    </el-popover>
                </div> -->
                <div style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap;" v-else>
                    <el-tooltip class="item" effect="dark" :content="scope.row[column.prop]" placement="top">
                       <span> {{ scope.row[column.prop]}}</span>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>

        <el-table-column fixed="right" width="200" align="center" label="操作" v-if="isOperate">
            <template slot-scope="scope">
                <slot :row='scope.row' :index='scope.$index'></slot>
            </template>
        </el-table-column>
        <div slot="empty" class="empty_material">
            <img src="@/assets/image/home/default.png" alt="加载失败" />
            <p>暂无数据</p>
        </div>
    </el-table>
</template>

<script>
export default {
    name: 'BasicTable',

    data() {
        return {
            pickerOptions: {
                disabledDate: (time) => {
                    if (this.title == '新建计划') {
                        let planBeginTime = new Date(this.planBeginTime)
                        let newEndTime = new Date(this.planEndTime)
                        if (this.planEndTime) {
                            return time.getTime() < Date.now() - 8.64e7 && time.getTime() < planBeginTime.getTime() || time.getTime() > newEndTime.getTime()
                        } else {
                            let planEditBeginTime = new Date(this.planEditBeginTime)
                            let planEditEndTime = new Date(this.planEditEndTime)
                            return time.getTime() < Date.now() && time.getTime() < planEditBeginTime.getTime() || time.getTime() > planEditEndTime.getTime()
                        }

                    } else {
                        let planBeginTime = new Date(this.planBeginTime)
                        let newEndTime = new Date(this.planEndTime)
                        let planEditBeginTime = new Date(this.planEditBeginTime)
                        let planEditEndTime = new Date(this.planEditEndTime)
                        if (this.planBeginTime || this.planEndTime) {
                            if (this.planEndTime) {
                                // let planEditBeginTime = new Date(this.planEditBeginTime)
                                return time.getTime() < Date.now() - 8.64e7 && time.getTime() < planEditBeginTime.getTime() || time.getTime() > newEndTime.getTime()
                            } else {
                                // let planEditBeginTime = new Date(this.planEditBeginTime)
                                // let planEditEndTime = new Date(this.planEditEndTime)
                                return time.getTime() < Date.now() - 8.64e7 && time.getTime() < planBeginTime.getTime() || time.getTime() > planEditEndTime.getTime()
                            }
                        } else if (planEditBeginTime || planEditEndTime) {
                            let planEditBeginTime = new Date(this.planEditBeginTime)
                            let planEditEndTime = new Date(this.planEditEndTime)
                            return time.getTime() < Date.now() - 8.64e7 && time.getTime() < planEditBeginTime.getTime() || time.getTime() > planEditEndTime.getTime()
                        }
                    }

                }
            },
            pickerOptionsCopy: {
                disabledDate: (time) => {
                    if (this.title == '新建计划') {
                        let planBeginTime = new Date(this.planBeginTime)
                        let newEndTime = new Date(this.planEndTime)
                        if (this.planEndTime) {
                            return time.getTime() < Date.now() && time.getTime() < planBeginTime.getTime() || time.getTime() > newEndTime.getTime()
                        } else {
                            let planEditBeginTime = new Date(this.planEditBeginTime)
                            let planEditEndTime = new Date(this.planEditEndTime)
                            return time.getTime() < Date.now() && time.getTime() < planEditBeginTime.getTime() || time.getTime() > planEditEndTime.getTime()
                        }
                    } else {
                        let planBeginTime = new Date(this.planBeginTime)
                        let newEndTime = new Date(this.planEndTime)
                        let planEditBeginTime = new Date(this.planEditBeginTime)
                        let planEditEndTime = new Date(this.planEditEndTime)
                        if (this.planBeginTime || this.planEndTime) {
                            if (this.planEndTime) {
                                // let planEditBeginTime = new Date(this.planEditBeginTime)
                                return time.getTime() < Date.now() - 8.64e7 && time.getTime() < planEditBeginTime.getTime() || time.getTime() > newEndTime.getTime()
                            } else {
                                // let planEditBeginTime = new Date(this.planEditBeginTime)
                                // let planEditEndTime = new Date(this.planEditEndTime)
                                return time.getTime() < Date.now() - 8.64e7 && time.getTime() < planBeginTime.getTime() || time.getTime() > planEditEndTime.getTime()
                            }
                        } else if (planEditBeginTime || planEditEndTime) {
                            let planEditBeginTime = new Date(this.planEditBeginTime)
                            let planEditEndTime = new Date(this.planEditEndTime)
                            return time.getTime() < Date.now() - 8.64e7 && time.getTime() < planEditBeginTime.getTime() || time.getTime() > planEditEndTime.getTime()
                        }
                    }
                }
            },
        };
    },
    props: {
        tableData: {
            // 表格数据
            type: [Array],
            default: function () {
                return []
            }
        },
        isCheckbox: {
            // 是否有复选框
            type: Boolean,
            default: function () {
                return false
            }
        },
        tableHeader: {
            // table表格表头
            type: [Array],
            default: function () {
                return []
            }
        },
        isOperate: {
            // 是否有操作一栏
            type: Boolean,
            default: function () {
                return true
            }
        },
        TableHeight: {
            // 表格高度
            type: [String],
            default: '82%'
        },
        isAddPrance: {
            type: [Boolean],
            default: false
        },
        planEndTime: {
            type: [String, Number, Boolean],
            default: function () {
                return false
            }
        },
        planBeginTime: {
            type: [String, Number, Boolean],
            default: function () {
                return false
            }
        },
        planEditBeginTime: {
            type: [String, Number, Boolean],
            default: function () {
                return false
            }
        },
        planEditEndTime: {
            type: [String, Number, Boolean],
            default: function () {
                return false
            }
        },
        isSelectPaper: {
            type: [Boolean],
            default: function () {
                return false
            }
        },
        title: {
            type: [String],
            default: function () {
                return ''
            }
        }
    },
    methods: {
        rowFun(row) {
            if (this.isAddPrance) {
                return row.provinceId
            } else if (this.isSelectPaper) {
                return row.paperId
            } else {
                return row.id
            }
        },
        getEditchange(data) { // 回显选中
            this.$nextTick(() => {
                for (let i = 0; i < data.length; i++) {
                    this.$refs.basicTable.toggleRowSelection(data[i], true)
                }
            })
        },
        getClearSelect() {
            this.$refs.basicTable.clearSelection()
        },
        selectChange(data) {
            this.$emit('operation', 'selectChange', data)
        },
        currentChange(data) {
            this.$emit('operation', 'currentChange', data)
        },
        onTableSelect(data1, data2) { // 判断当前行是否选中
            this.$emit('operation', 'select', data2)
        },
        changeDatePickerBeginTime() {
            // this.basicBeginTime = new Date(val)
        },
        changeDatePicker() {
            //  this.$emit('operation', 'select', data)
        },
        selectable(row) {
            if (row.isEdited) {
                return false
            } else {
                return true
            }

        }
    }
};
</script>

<style lang="scss" scoped>
.table {
    border: 1px solid #f4f4f4;
    border-radius: 5px;

    .empty_material {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        p {
            color: #ccc;
            // margin: 0;
        }
    }
}

/deep/.el-tooltip__popper {
    max-width: 500px;
}

::-webkit-scrollbar-track-piece {
    background-color: #fff;
    -webkit-border-radius: 0;
}

::-webkit-scrollbar {
    width: 5px;
    height: 10px;
}

::-webkit-scrollbar-thumb {
    height: 50px;
    background-color: #b8b8b8;
    -webkit-border-radius: 6px;
    outline: 2px solid #fff;
    outline-offset: -2px;
    border: 2px solid #fff;
    filter: alpha(opacity=50);
    -moz-opacity: 0.5;
    -khtml-opacity: 0.5;
    opacity: 0.5;
}

::-webkit-scrollbar-thumb:hover {
    height: 50px;
    background-color: #878987;
    -webkit-border-radius: 6px;
}</style>

<style lang="scss">.el-tooltip__popper {
    max-width: 800px;
}</style>